import * as Service from '../service/service'

export default {
    namespace: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {}
}
